module.exports = __webpack_public_path__ + "img/mdzs.73c5e54d.png";